import { render, staticRenderFns } from "./fullAgeTerm.vue?vue&type=template&id=4f59d195"
import script from "./fullAgeTerm.vue?vue&type=script&lang=js"
export * from "./fullAgeTerm.vue?vue&type=script&lang=js"
import style0 from "./fullAgeTerm.vue?vue&type=style&index=0&id=4f59d195&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports